import React, { useMemo, useState } from "react";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import Box from "@mui/material/Box";
import {
  DataGridPro,
  type GridColDef,
  type GridPaginationModel,
} from "@mui/x-data-grid-pro";

type UserData = {
  id: number;
  name: string;
  email: string;
};

const fetchUsers = async (page: number, limit: number) => {
  const response = await axios.get<UserData[]>("http://localhost:4000/users", {
    params: {
      _page: page,
      _limit: limit,
    },
  });

  return {
    rows: response.data,
    rowCount: response.headers["x-total-count"],
  };
};

const DataGridServer: React.FC = () => {
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: 10,
  });

  const { data, isLoading, isPlaceholderData } = useQuery({
    queryKey: ["users", paginationModel],
    queryFn: () =>
      fetchUsers(paginationModel.page + 1, paginationModel.pageSize),
  });

  const rowCount: number = useMemo(() => data?.rowCount, [data?.rowCount]);

  const columns: GridColDef[] = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "name", headerName: "Name", width: 200 },
    { field: "email", headerName: "Email", width: 250 },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: 630,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <DataGridPro
        rows={data?.rows || []}
        columns={columns}
        pagination
        paginationMode="server"
        pageSizeOptions={[10, 25, 50, 100]}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        rowCount={rowCount}
        loading={isLoading || isPlaceholderData}
        slotProps={{
          loadingOverlay: {
            variant: "linear-progress",
            noRowsVariant: "skeleton",
          },
        }}
      />
    </Box>
  );
};

export default DataGridServer;
